/* eslint-disable no-prototype-builtins */
/* eslint-disable complexity */
import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * 'checkboxRequiredValidator' this method used to validate if the checkbox is checked or not and based on that showing error state for checkbox
 */

export function checkboxRequiredValidator(): ValidatorFn {
  return (
    control: AbstractControl
  ): {
    [key: string]: unknown;
  } | null => {
    if (control && control.value) {
      let val = '';

      if (control.value.hasOwnProperty('value')) {
        val = control.value.value;
      } else {
        val = control.value;
      }

      return val
        ? null
        : {
            checkboxRequired: true
          };
    }
    return {
      checkboxRequired: true
    };
  };
}
